import { render } from "./PeopleCountTag.vue?vue&type=template&id=b0a4dfa8&scoped=true&ts=true"
import script from "./PeopleCountTag.vue?vue&type=script&lang=ts"
export * from "./PeopleCountTag.vue?vue&type=script&lang=ts"

import "./PeopleCountTag.vue?vue&type=style&index=0&id=b0a4dfa8&scoped=true&lang=scss"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0a4dfa8"]])

export default __exports__